import Api from '@/services/Api'

export default {
    getAllTasas(){
        return Api().get('tasa/getAll')
    },
    getTasaById(id){
        return Api().get('tasa/tasaById/'+id)
    },
    getTasaByFechaIniAndCodTasa(fechaInicial,codigoTasa){
        return Api().get('tasa/tasaByFechaIniAndCodTasa/'+fechaInicial+'/'+codigoTasa)
    },
    createTasa(datos){
        return Api().post('tasa/create',datos)
    },
    updateTasaById(datos){
        return Api().put('tasa/update',datos)
    },
    deleteTasa(id){
        return Api().delete('tasa/delete/'+id)
    },
    generarTasa(datos){
        return Api().post('tasa/generarTasa',datos)
    },

	grabeTasa(vigencia,tipo_tasa,tasa,userId) {
		let dato={}
		dato.vigencia=vigencia
		dato.tipo_tasa=tipo_tasa
		dato.tasa=tasa
		dato.userId=userId
		return Api().put('tasa/grabeTasa',dato)
	},

	interpolacion(fechaInicial,cuotas) {
		return Api().get('tasa/interpolacion/'+fechaInicial+'/'+cuotas)
	},

}
